import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="badges">
        <div className="badge">Terapisti<br />Certificati</div>
        <div className="badge">Oli<br />Organici</div>
        <div className="badge">Acqua<br />Ozono</div>
      </div>

      <div className="footer-grid">
        <div className="footer-col">
          <h4>Servizi</h4>
          <ul>
            <li><a href="/">Idroterapia</a></li>
            <li><a href="/">Massaggio Infantile</a></li>
            <li><a href="/">Corsi Genitori</a></li>
            <li><a href="/">Pacchetti</a></li>
            <li><a href="/">Buoni Regalo</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Chi Siamo</h4>
          <ul>
            <li><a href="/">La Nostra Storia</a></li>
            <li><a href="/">Standard di Sicurezza</a></li>
            <li><a href="/">Il Team</a></li>
            <li><a href="/">Lavora con noi</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Risorse</h4>
          <ul>
            <li><a href="/">Benefici della Spa</a></li>
            <li><a href="/">Blog Neogenitori</a></li>
            <li><a href="/">FAQ</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Sedi</h4>
          <ul>
            <li><a href="/">Milano</a></li>
            <li><a href="/">Roma</a></li>
            <li><a href="/">Torino</a></li>
            <li><a href="/">Napoli</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Contatti</h4>
          <ul>
            <li><a href="/">Scrivici</a></li>
            <li><a href="/">Supporto</a></li>
            <li><a href="/">Stampa</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="socials">
          <i className="fa-brands fa-facebook-f"></i>
          <i className="fa-brands fa-twitter"></i>
          <i className="fa-brands fa-instagram"></i>
          <i className="fa-brands fa-youtube"></i>
        </div>
        <p>Baby Bolle Spa S.r.l. Tutti i diritti riservati.</p>
        <p>&copy; 2026 Baby Bolle Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
